/**
 * Native Platform Detection Service
 * Detects if the app is running in a native Capacitor shell vs web browser
 */

import { Capacitor } from '@capacitor/core';

export const platformService = {
  /**
   * Check if running as a native app (iOS/Android)
   */
  isNative: () => Capacitor.isNativePlatform(),
  
  /**
   * Get the current platform
   * @returns 'ios' | 'android' | 'web'
   */
  getPlatform: () => Capacitor.getPlatform(),
  
  /**
   * Check if running on iOS
   */
  isIOS: () => Capacitor.getPlatform() === 'ios',
  
  /**
   * Check if running on Android
   */
  isAndroid: () => Capacitor.getPlatform() === 'android',
  
  /**
   * Check if running in web browser
   */
  isWeb: () => Capacitor.getPlatform() === 'web',
  
  /**
   * Check if a plugin is available on current platform
   */
  isPluginAvailable: (pluginName) => Capacitor.isPluginAvailable(pluginName),
  
  /**
   * Get device info for analytics
   */
  getDeviceInfo: () => ({
    platform: Capacitor.getPlatform(),
    isNative: Capacitor.isNativePlatform(),
    // Additional device info can be added via @capacitor/device plugin
  })
};

export default platformService;
